import styled, { keyframes } from "styled-components";

const enterAnimation = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }
`;

export const Container = styled.div`
  animation: ${enterAnimation} 300ms;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;
  overflow: hidden;
  @media (max-width: 1200px) {
    flex-direction: column;
    height: auto;
  }
`;

export const Section = styled.section`
  //background: ${(props) => props.theme.configs.cor_fundo};
  padding-left: 5px;
  width: 60.41%;
  height: 100%;
  display: flex;
  padding-top: 5.4rem;
  align-items: flex-start;
  flex-direction: column;
  padding-left: 10.7rem;
  overflow: auto;
  padding-bottom: 7%;
  @media (max-width: 1200px) {
    overflow: unset;
    text-align: center;
    margin: 0 0 8rem 0;
    width: 100%;
    padding-left: 0;
  }

  p {
    font-family: "Galano";
    line-height: 2.1rem;
    font-size: calc(1.6rem * var(--font-size-scale));
    font-weight: 600;
    font-style: normal;
    //color: ${(props) => props.theme.configs.cor_texto};
    margin-bottom: 2.5rem;
    margin-right: 7.9rem;
    @media (max-width: 1200px) {
      margin: 0 0 6rem 0;
      width: 100%;
      line-height: 2.5rem;
      font-size: calc(2rem * var(--font-size-scale));
      texta-align: center;
    }

    & + p {
      //color: ${(props) => props.theme.configs.cor_texto};
      font-family: "Galano";
      line-height: 2.2rem;
      font-size: calc(1.7rem * var(--font-size-scale));
      font-weight: 300;
      font-style: normal;
    }
  }
  @media (max-width: 1200px) {
    width: 80%;
    padding-top: 3rem;
    margin: 0;
    display: flex;
  }
`;

export const Gallery = styled.div`
  width: 90%;

  display: flex;
  flex-wrap: wrap;

  @media (max-width: 1200px) {
    width: 100%;
    justify-content: space-between;
  }

  .column {
    flex: 25%;
    //max-width: 32%;
    margin-right: 1.2rem;
    @media (max-width: 768px) {
      flex: 100%;
      max-width: 100%;
      margin: 0;
    }
  }
`;

interface IGalleryItemProps {
  isVisible: boolean;
}

export const GalleryItem = styled.div<IGalleryItemProps>`
  position: relative;
  margin-bottom: 1.2rem;

  img {
    vertical-align: middle;
    width: 100%;
    user-select: none;
  }

  .onhover {
    position: absolute;
    width: 130% !important;
    height: 130%;
    opacity: 0;
    top: 50%;
    left: 50%;
    z-index: 999;
    transform: translate(-50%, -50%);
    @media (max-width: 1200px) {
      visibility: hidden;
    }
    &:hover {
      opacity: 1;
    }
  }

  label {
    & > img {
      filter: ${(props) => (props.isVisible ? "brightness(50%)" : "none")};
    }
  }

  .onSelect {
    height: 100%;
    width: 100%;

    z-index: 999;
    position: absolute;
    inset: 0;

    display: ${(props) => (props.isVisible ? "flex" : "none")};

    justify-content: center;
    align-items: center;

    .POC {
      width: 100px;
      height: 100px;
    }
  }

  input {
    position: absolute;
    opacity: 0;
  }

  .check-icon {
    padding: 30%;
  }
`;

export const NavigateButtons = styled.div`
  width: 100%;
  position: absolute;
  bottom: 2rem;
  display: flex;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 4rem;
  z-index: 999;
  @media (max-width: 1200px) {
    position: fixed;
    bottom: 0;
    padding: 2rem 10%;
    background: transparent linear-gradient(0deg, #ffffff 0%, #ffffff00 100%) 0%
      0% no-repeat padding-box;
  }
`;

export const Modal = styled.div`
  position: fixed;
  width: 80%;
  height: 100vh;
  padding: 10%;
  top: 50%; right: 50%;
  transform: translate(50%,-50%);
  pointer-events: none;
  //background: rgba(0,0,0, 0.8);
  img {
    display: flex;
    height: 100%;
    width: 100%;
    object-fit: contain;
    @media (max-width: 1200px) {
      object-fit: cover; 
    }
  }
  z-index: 9999;
`;
